import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setPortal } from 'modules/portal';
import { makeRowColumn, getHeadObj, dataConverter } from 'lib/commonLib';
import { paramConverter } from 'modules/common';
import { dailyCategoryRoas } from 'lib/api/time';

import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import VariousCell from 'components/molecules/MbTable/VariousCell';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import CategoryFilter from 'components/organisms/CategoryFilter';

import CategoryStatisticsGraph from './CategoryStatisticsGraph';
import TopCategoryStatisticsGraph from './TopCategoryStatisticsGraph';
import queryString from 'query-string';

const CategoryStatistics = ({ location }) => {
  let initParams = {
    pltfomTpCode: 'all',
    itlTpCode: 'all',
    sort: 'desc',
    order: 'STATS_DTTM',
    sDate: moment().subtract(1, 'days').subtract(1, 'month').format('YYYYMMDD'),
    eDate: moment().subtract(1, 'days').format('YYYYMMDD'),
  };

  const convertKeys = [
    'adverId',
    'mediaScriptNo',
    'advrtsPrdtCode',
    'advrtsTpCode',
    'pltfomTpCode',
    'sDate',
    'eDate',
    'uri',
  ];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  // header 및 body 컬럼 커스텀
  const customized = {
    STATS_DTTM: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
        const dateValue = makeRowColumn(
          rowObj['STATS_DTTM'],
          'date',
          'YYYY-MM-DD'
        );
        var dayOfWeek = new Date(dateValue).getDay();
        let resultComponent;
        let dayColor;
        if (dayOfWeek === 0) {
          dayColor = {
            color: 'red',
          };
        } else if (dayOfWeek === 6) {
          dayColor = {
            color: 'blue',
          };
        }
        if (rowObj.isChild) {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['STATS_DTTM'],
                statsDttm.type,
                statsDttm.format
              )}
            </>
          );
        } else {
          resultComponent = (
            <p style={dayColor}>
              {makeRowColumn(
                rowObj['STATS_DTTM'],
                statsDttm.type,
                statsDttm.format
              )}
            </p>
          );
        }
        return resultComponent;
      },
    },
    CLICK_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'CLICK_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const clickCnt = getHeadObj(headsMap, 'CLICK_CNT');
        const convertKeys = [
          'advrtsPrdtCode',
          'advrtsTpCode',
          'pltfomTpCode',
          'itlTpCode',
        ];
        const addParams = dataConverter(params, convertKeys, 'string');
        const showWindowUrl =
          '/report/adver/statistics?sDate=' +
          rowObj['STATS_DTTM'] +
          '&eDate=' +
          rowObj['STATS_DTTM'] +
          '&uri=/report/adver/statistics&isPop=1' +
          addParams;

        let resultComponent;
        if (rowObj.isChild) {
          resultComponent = (
            <>
              {makeRowColumn(
                rowObj['CLICK_CNT'],
                clickCnt.type,
                clickCnt.format
              )}
            </>
          );
        } else {
          resultComponent = (
            <IconAreaWrap
              text={makeRowColumn(
                rowObj['CLICK_CNT'],
                clickCnt.type,
                clickCnt.format
              )}
              icon={rowObj['STATS_DTTM'] !== 'total' && 'faExternalLink'}
              toolTipTitle={t('해당 날짜의 광고주별 통계')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          );
        }
        return resultComponent;
      },
    },
    ADVER_CNT: {
      makeHead: (headsMap) => {
        return `${getHeadObj(headsMap, 'ADVER_CNT').label}`;
      },
      makeBody: (rowObj, headsMap) => {
        const adverCnt = getHeadObj(headsMap, 'ADVER_CNT');
        // const totAdverCnt = getHeadObj(headsMap, 'TOT_ADVER_CNT');
        return (
          <>
            {makeRowColumn(rowObj['ADVER_CNT'], adverCnt.type, adverCnt.format)}
          </>
        );
      },
    },
    TOT_ADVER_CNT: {
      merged: true,
    },
    PAR_EPRS_CNT: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'PAR_EPRS_CNT').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const parEprsCnt = getHeadObj(headsMap, 'PAR_EPRS_CNT');
        // const reqCnt = getHeadObj(headsMap, 'REQ_CNT');
        return (
          <>
            {makeRowColumn(
              rowObj['PAR_EPRS_CNT'],
              parEprsCnt.type,
              parEprsCnt.format
            )}
          </>
        );
      },
    },
    REQ_CNT: {
      merged: true,
    },
    RES_RATE: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'RES_RATE').label}
            <br />({getHeadObj(headsMap, 'ENT_RATE').label})
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const resRate = getHeadObj(headsMap, 'RES_RATE');
        const entRate = getHeadObj(headsMap, 'ENT_RATE');
        return (
          <>
            {makeRowColumn(rowObj['RES_RATE'], resRate.type, resRate.format)}
            <br />(
            {makeRowColumn(rowObj['ENT_RATE'], entRate.type, entRate.format)})
          </>
        );
      },
    },
    ENT_RATE: {
      merged: true,
    },
    ADVRTS_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'ADVRTS_AMT').label}
            <br />({getHeadObj(headsMap, 'TRGT_ADVRTS_AMT').label})
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const advrtsAmt = getHeadObj(headsMap, 'ADVRTS_AMT');
        const trgtAdvrtsAmt = getHeadObj(headsMap, 'TRGT_ADVRTS_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['ADVRTS_AMT'],
              advrtsAmt.type,
              advrtsAmt.format
            )}
            <br />
            <div className="black">
              (
              {makeRowColumn(
                rowObj['TRGT_ADVRTS_AMT'],
                trgtAdvrtsAmt.type,
                trgtAdvrtsAmt.format
              )}
              )
            </div>
          </>
        );
      },
    },
    TRGT_ADVRTS_AMT: {
      merged: true,
    },
    ORDER_CNT: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'ORDER_CNT').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const orderCnt = getHeadObj(headsMap, 'ORDER_CNT');
        const convertKeys = [
          'advrtsPrdtCode',
          'advrtsTpCode',
          'pltfomTpCode',
          'itlTpCode',
        ];
        const addParams = dataConverter(params, convertKeys, 'string');
        const showWindowUrl =
          '/report/conversion/detail?sDate=' +
          rowObj['STATS_DTTM'] +
          '&eDate=' +
          rowObj['STATS_DTTM'] +
          '&uri=/report/conversion/detail&isPop=1' +
          addParams;

        return (
          <IconAreaWrap
            text={makeRowColumn(
              rowObj['ORDER_CNT'],
              orderCnt.type,
              orderCnt.format
            )}
            icon={rowObj['STATS_DTTM'] !== 'total' && 'faExternalLink'}
            toolTipTitle={t('해당 날짜의 일자별 컨버전리스트')}
            onClick={(e) => handlePortalUrl(showWindowUrl)}
          />
        );
      },
    },

    AVG_ORDER_AMT: {
      makeHead: (headsMap) => {
        return <>{getHeadObj(headsMap, 'AVG_ORDER_AMT').label}</>;
      },
      makeBody: (rowObj, headsMap) => {
        const avgOrderAmt = getHeadObj(headsMap, 'AVG_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['AVG_ORDER_AMT'],
              avgOrderAmt.type,
              avgOrderAmt.format
            )}
          </>
        );
      },
    },
    MOB_SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'MOB_SESSION_ORDER_AMT').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'MOB_SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const mobSessionRoas = getHeadObj(headsMap, 'MOB_SESSION_ROAS');
        const trgtMobSessionRoas = getHeadObj(
          headsMap,
          'TRGT_MOB_SESSION_ROAS'
        );
        const mobSessionOrderAmt = getHeadObj(
          headsMap,
          'MOB_SESSION_ORDER_AMT'
        );
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['MOB_SESSION_ROAS'],
              mobSessionRoas.type,
              mobSessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_MOB_SESSION_ROAS'],
              trgtMobSessionRoas.type,
              trgtMobSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['MOB_SESSION_ORDER_AMT'],
              mobSessionOrderAmt.type,
              mobSessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_MOB_SESSION_ORDER_AMT: {
      merged: true,
    },
    MOB_SESSION_ORDER_AMT: {
      merged: true,
    },
    SESSION_ROAS: {
      makeHead: (headsMap) => {
        return {
          content: (
            <>
              <InfoTitleArea
                title={
                  getHeadObj(headsMap, 'SESSION_ORDER_AMT').label +
                  '(' +
                  t('쇼핑') +
                  ')'
                }
                tooltipType={'SESSION_ROAS'}
                iconType="fainfoCircle"
              />
            </>
          ),
          orderFlag: true,
        };
      },
      makeBody: (rowObj, headsMap) => {
        const sessionRoas = getHeadObj(headsMap, 'SESSION_ROAS');
        const trgtSessionRoas = getHeadObj(headsMap, 'TRGT_SESSION_ROAS');
        const sessionOrderAmt = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['SESSION_ROAS'],
              sessionRoas.type,
              sessionRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_SESSION_ROAS'],
              trgtSessionRoas.type,
              trgtSessionRoas.format
            )}
            item3={makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              sessionOrderAmt.type,
              sessionOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_SESSION_ROAS: {
      merged: true,
    },
    SESSION_ORDER_AMT: {
      merged: true,
    },
    DIRECT_ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label +
                '(' +
                t('쇼핑') +
                ')'
              }
              tooltipType={'DIRECT_ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const directRoas = getHeadObj(headsMap, 'DIRECT_ROAS');
        const trgtDirectRoas = getHeadObj(headsMap, 'TRGT_DIRECT_ROAS');
        const directOrderAmt = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(
              rowObj['DIRECT_ROAS'],
              directRoas.type,
              directRoas.format
            )}
            item2={makeRowColumn(
              rowObj['TRGT_DIRECT_ROAS'],
              trgtDirectRoas.type,
              trgtDirectRoas.format
            )}
            item3={makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              directOrderAmt.type,
              directOrderAmt.format
            )}
          />
        );
      },
    },
    TRGT_DIRECT_ROAS: {
      merged: true,
    },
    DIRECT_ORDER_AMT: {
      merged: true,
    },
    ROAS: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={
                getHeadObj(headsMap, 'ORDER_AMT').label + '(' + t('쇼핑') + ')'
              }
              tooltipType={'ROAS'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const roas = getHeadObj(headsMap, 'ROAS');
        const trgtRoas = getHeadObj(headsMap, 'TRGT_ROAS');
        const orderAmt = getHeadObj(headsMap, 'ORDER_AMT');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ROAS'], roas.type, roas.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ROAS'],
              trgtRoas.type,
              trgtRoas.format
            )}
            item3={makeRowColumn(
              rowObj['ORDER_AMT'],
              orderAmt.type,
              orderAmt.format
            )}
          />
        );
      },
    },
    TRGT_ROAS: {
      merged: true,
    },
    ORDER_AMT: {
      merged: true,
    },
    ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            <InfoTitleArea
              title={getHeadObj(headsMap, 'ECPM').label + '(' + t('쇼핑') + ')'}
              tooltipType={'ECPM'}
              iconType="fainfoCircle"
            />
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const ecpm = getHeadObj(headsMap, 'ECPM');
        const trgtEcpm = getHeadObj(headsMap, 'TRGT_ECPM');
        return (
          <VariousCell
            type="TRGT"
            item1={makeRowColumn(rowObj['ECPM'], ecpm.type, ecpm.format)}
            item2={makeRowColumn(
              rowObj['TRGT_ECPM'],
              trgtEcpm.type,
              trgtEcpm.format
            )}
          />
        );
      },
    },
    TRGT_ORDER_AMT: {
      merged: true,
    },
    TRGT_ECPM: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 필터 선택 관련
   */
  const handleOnchangeFilter = (filterParam) => {
    setParams({ ...params, ...filterParam });
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={params}
          getParam={getParam}
        />
        <CategoryFilter
          initialization={initialization}
          handleOnchangeFilter={handleOnchangeFilter}
        />
      </NewFilterWrap>

      <CategoryStatisticsGraph params={{ ...paramConverter(params) }} />
      <TopCategoryStatisticsGraph params={{ ...paramConverter(params) }} />

      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={dailyCategoryRoas}
        customized={customized}
        rowsPerPage={-1}
        useFetch={false}
        useSearch={false}
        usePagenation={false}
      />
    </>
  );
};

export default withRouter(CategoryStatistics);
